import { DataCard } from '../../../components/DashboardCard';
import { useMessagingAnalytics } from '../../../hooks/Dashboard/useMessagingAnalytics';

export const MessagesCard = (props: DashboardMessagesCard) => {
  const { isRes, theme } = props;
  const { messagingAnalytics, getMessagingAnalytics, loading } =
    useMessagingAnalytics();

  const resColumns = [
    { name: 'Start Date', dataKey: 'startDate' },
    { name: 'Subject', dataKey: 'subject' },
    { name: 'Sent', dataKey: 'totalSent', isNumeric: true },
    { name: 'Read', dataKey: 'totalRead', isNumeric: true },
    { name: 'Hits', dataKey: 'totalHits', isNumeric: true },
  ];
  const hosColumns = [
    { name: 'Disposition', dataKey: 'id' },
    { name: '#', dataKey: 'value', isNumeric: true },
    { name: '% Read', dataKey: 'percentRead', isNumeric: true },
  ];

  return (
    <DataCard
      data={messagingAnalytics}
      title="Messages"
      views={['list', 'graph', 'pie']}
      columns={isRes ? resColumns : hosColumns}
      leftLabel={isRes ? 'Read' : 'Count'}
      bottomLabel={isRes ? 'Message Id' : 'Disposition'}
      loading={loading}
      refresh
      onRefresh={getMessagingAnalytics}
      enableTimespan
      theme={theme}
    />
  );
};
